module.exports = __webpack_public_path__ + "static/media/cd2-icon-pending.cdcd0b99.svg";